import HeadUrl from '../api/headurl'


const state = {
  title: 'headurl',
  imageUrl: '',
  urlList: [],
  groupmember: [],
  urlObj: {},
  beforeurl: "http://files.cochat.lenovo.com/download/dbb26a06-4604-3d2b-bb2c-6293989e63a7/"
}

const getters = {
  // headSrc: (state) => (params) => {
  //   let src = ''
  //   // console.log(state.urlList)
  //   if (state.urlList) {
  //     // console.log(state.urlList)
  //     state.urlList.filter(item => {
  //       if (item.itCode == params) {
  //         src = item.simageUri
  //         // console.log(src)
  //       }
  //     })
  //   }
  //   src = state.beforeurl + src;
  //   return src;
  // }
}

const mutations = {
  async getUrl(state, params) {
    // console.log(params, 'url')
    let data = await HeadUrl.head_url(params.toString())
    // console.log(data.length)
    state.urlList = data
    // console.log(state.urlList,'urlll')
  },

  setUrl(state, params) {
    let arr = state.urlList.filter(item => {
      return item.itCode === params.itCode
    })
    // console.log(arr)
    if (arr.length == 0) {
      let list = state.urlList
      list.push(params)
      state.urlList = list
      // console.log(state.urlList)
    }
  },


  async getMember(state, params) {
    let data = await HeadUrl.getGroup_memeber(params)
    // console.log(data.data.users)
    state.groupmember = data.data.users
  }

}



export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/headurl.js